import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { getStationDate } from 'utils/converter';
import { getGate } from 'utils/flight';

const primaryBlue = '#05164D';

const styles = StyleSheet.create({
  headerContainer: { marginTop: 10, },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 15,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  label: {
    fontSize: 8,
    lineHeight: 'normal',
    textTransform: 'uppercase',
    fontFamily: 'NunitoBold',
    color: 'white',
    backgroundColor: primaryBlue,
    padding: 4,
    textAlign: 'center',
    marginBottom: 2,

  },
  flightNumberLabel: {
    fontSize: 12,
    paddingBottom: 3,
    lineHeight: 'normal',
    color: primaryBlue,
    fontFamily: 'NunitoRegular',
  },
  flightNumberData: {
    fontSize: 12,
    paddingBottom: 3,
    lineHeight: 'normal',
    color: primaryBlue,
    fontFamily: 'NunitoRegular',
  },
  data: {
    fontSize: 10,
    lineHeight: 'normal',
    color: primaryBlue,
    fontFamily: 'NunitoRegular',
    fontWeight: 'normal',
    textAlign: 'center',
  },
  fSpaceBtw:{
    flexDirection: 'row',
    justifyContent: 'space-between', 
  },
  row:{
    flexDirection: 'row',
    padding: 0,
    borderWidth: 1,
    borderColor: `${primaryBlue}`,
  },
  directionRow:{
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center' 
  },
  infoSm:{
    width: '10%',
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: `${primaryBlue}`,
  },
  infoMd:{
    width: '16%',
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: `${primaryBlue}`,
  },
  info:{
    width: '14%',
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: `${primaryBlue}`,
  },
  infoLg:{
    width: '18%',
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: `${primaryBlue}`,
  },
  pb10: { paddingBottom: 10 }
});


const FlightInfo = (props) => {
  const { info } = props;

  return (
    <View style={styles.headerContainer}>
      <Text style={styles.title}>Flight Info</Text>
      
      <View style={styles.row}>
        <View style={styles.infoSm}>
          <Text style={styles.label}>AC Type</Text>
          <Text style={styles.data}>{info?.ac_type}</Text>
        </View>     
        <View style={styles.infoMd}>
          <Text style={styles.label}>Registration</Text>
          <Text style={styles.data}>{info?.reg_no}</Text>
        </View>
        <View style={styles.info}>
          <Text style={styles.label}>Platform</Text>
          <Text style={styles.data}>{info?.platform}</Text>
        </View>
        <View style={styles.info}>
          <Text style={styles.label}>Routing</Text>
          <Text style={styles.data}>{info?.org + '-' + info?.dest}</Text>
        </View>
        <View style={styles.infoLg}>
          <Text style={styles.label}>Departure</Text>
          <View style={styles.directionRow}>
            <Text style={styles.data}>{info?.act_dept ? 
              getStationDate(info?.org, info?.act_dept, 'DDMMMYY HHmm') : (info?.est_dept ? 
                getStationDate(info?.org, info?.est_dept, 'DDMMMYY HHmm') : (info?.schdl_dept ? 
                  getStationDate(info?.org, info?.schdl_dept, 'DDMMMYY HHmm') : null))}</Text>
            <Text style={styles.data}>{info?.act_dept ? ' (A)' : (info?.est_dept ? ' (E)' : ' (S)')}</Text>
          </View>
        </View>     
        <View style={styles.infoLg}>
          <Text style={styles.label}>Arrival</Text>
          <View style={styles.directionRow}>
            <Text style={styles.data}>{info?.act_arr ? 
              getStationDate(info?.dest, info?.act_arr, 'DDMMMYY HHmm') : (info?.est_arr ? 
                getStationDate(info?.dest, info?.est_arr, 'DDMMMYY HHmm') : (info?.schdl_arr ? 
                  getStationDate(info?.dest, info?.schdl_arr, 'DDMMMYY HHmm') : null))}</Text>
            <Text style={styles.data}>{info?.act_arr ? ' (A)' : (info?.est_arr ? ' (E)' : ' (S)')}</Text>
          </View>
        </View>      
        <View style={styles.infoSm}>
          <Text style={[styles.label, { borderRight: 'none' }]}>Gate</Text>
          <Text style={styles.data}>{getGate(info)}</Text>
        </View>
      </View>
    </View>
  );
};
  
export default FlightInfo;